import React, { useRef, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import "./ContactUs.css";

const Contact = () => {
    const [formData, setFormData] = useState({
        fullname: "",
        email: "",
        mobile: "",
        message: "",
        SubId: "Contact Enquiry Form Yark Hills",
    });

    const [submitted, setSubmitted] = useState(false); // State to track form submission
    const formRef = useRef(null);

    // Handle form field changes
    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "fullname") {
            // Allow only alphabets and spaces
            if (/^[A-Za-z\s]*$/.test(value) || value === "") {
                setFormData({ ...formData, [name]: value });
            }
        } else if (name === "mobile") {
            // Allow only positive numbers and restrict to 10 characters
            if (/^\d*$/.test(value) && value.length <= 10) {
                setFormData({ ...formData, [name]: value });
            }
        } else {
            // For other fields, directly set value
            setFormData({ ...formData, [name]: value });
        }
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();

        // Generate the timestamp when the form is submitted
        const timestamp = new Date().toISOString();

        // Creating FormData and adding extra fields (subId and timestamp)
        const formDataObj = new FormData(formRef.current);
        formDataObj.append("timestamp", timestamp); // Add timestamp to the form data

        // Send the form data via fetch
        fetch(
            "https://script.google.com/macros/s/AKfycbzkHNf5ex37YcbMS2BVCuykELtKM_C9vr2PqyeQ5HWfWSv3w8jBBIKPW9_wjo-PRus/exec",
            {
                method: "POST",
                body: formDataObj, // Send the populated formData
            }
        )
            .then((res) => {
                if (!res.ok) {
                    throw new Error("Network response was not ok");
                }
                return res.json();
            })
            .then((data) => {
                console.log(data);
                formRef.current.reset(); // Clear form fields
                setFormData({
                    fullname: "",
                    email: "",
                    mobile: "",
                    message: "",
                });
                setSubmitted(true); // Set submitted state to true
                setTimeout(() => setSubmitted(false), 5000); // Hide message after 5 seconds
            })
            .catch((err) => {
                console.error("There was a problem with the fetch operation:", err);
                alert("Submission failed. Please try again.");
            });
    };

    return (
        <>
            <div class="p-4 breadcrumb-container">
                <ol class="breadcrumb text-center">
                    <li class="breadcrumb-item"><a href="/">Home</a></li>
                    <li class="breadcrumb-item"><a href="#">Contact Us</a></li>
                </ol>
            </div>

            <section id="ContactUs" className="con" >
                <div className="innerContact">
                    <div className="container-fluid">
                        {/* <h3 className="text-center section-head">Contact Us</h3> */}
                        <div className="row justify-content-center">
                            <div className="col-11">
                                <div className="row align-items-center con-box" style={{ padding: "30px 0" }}>
                                    {/* Left Image Column */}
                                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 ContactSubbox nopadding">
                                        <div className="map-container">
                                            <iframe className="map-container" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d30143.522162681416!2d72.866964!3d19.197811!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b7c65f564323%3A0x2447efcbf6c8869a!2sFun%204%20u%20Events!5e0!3m2!1sen!2sin!4v1742298241603!5m2!1sen!2sin" width="600" height="450"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                        </div>
                                    </div>
                                    {/* Contact Form */}
                                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 ContactSubbox1">
                                        <Form
                                            ref={formRef}
                                            onSubmit={handleSubmit}
                                            style={{
                                                textAlign: "left",
                                                backgroundColor: "white",
                                                padding: "5%",
                                                borderRadius: "15px",
                                            }}
                                        >
                                            <h3 className="text-center">Balloon Decoration</h3>
                                            <Form.Group className="mb-3" controlId="formName">
                                                <Form.Label>Name</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter Name"
                                                    name="fullname"
                                                    required
                                                    value={formData.fullname}
                                                    onChange={handleChange}
                                                />
                                            </Form.Group>

                                            <Form.Group className="mb-3">
                                                <div className="row">
                                                    <div className="col-md-6 mb-3">
                                                        <Form.Label>Email Id</Form.Label>
                                                        <Form.Control
                                                            type="email"
                                                            placeholder="Enter email"
                                                            name="email"
                                                            required
                                                            value={formData.email}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <Form.Label>Mobile No</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Enter Number"
                                                            name="mobile"
                                                            required
                                                            value={formData.mobile}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                            </Form.Group>

                                            <Form.Group className="mb-3" controlId="Description">
                                                <Form.Label>Message</Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={3}
                                                    name="message"
                                                    required
                                                    value={formData.message}
                                                    onChange={handleChange}
                                                />
                                            </Form.Group>

                                            <div className="con-btn text-center">
                                                <Button variant="success" type="submit" className="btn " style={{ backgroundColor: "#ff66b2" }}>
                                                    SEND MESSAGE
                                                </Button>
                                            </div>

                                            {/* Conditional rendering for the thank-you message */}
                                            {submitted && (
                                                <Form.Group className="mt-3">
                                                    <Form.Control
                                                        type="text"
                                                        value="Thank you for your submission!"
                                                        readOnly
                                                        style={{
                                                            textAlign: "center",
                                                            backgroundColor: "#25d366",
                                                            fontWeight: "bold",
                                                        }}
                                                    />
                                                </Form.Group>
                                            )}
                                        </Form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Contact;
